import { render } from "./CateStat.vue?vue&type=template&id=3a768603&scoped=true"
import script from "./CateStat.vue?vue&type=script&lang=js"
export * from "./CateStat.vue?vue&type=script&lang=js"

import "./CateStat.vue?vue&type=style&index=0&id=3a768603&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a768603"]])

export default __exports__